
































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {SystemNode} from '../system/interfaces';
import FacilityStructureTreeHelp from '@v/dashboard/FacilityStructureTreeHelp.vue';

@Component({
  components: {
    FacilityStructureTreeHelp,
  },
})
export default class Breadcrumbs extends Vue {
  @Prop() items!: any;

  @Prop()
  selectedNodes!: string[];

  @Prop()
  allItems!: SystemNode[];

  @Prop({type: Boolean, default: true})
  fst_help!: boolean;

  itemChilds: string[] = [];

  // при изменении selectedNode в настройках,
  @Watch('selectedNodes')
  onSelectedNodeId(newValue: string[]) {
    this.itemChilds = [];
    this.allItems.forEach(x => this.findItemChildrens(x, newValue));
  }

  // формируем массив узлов, по которым можно будет переходить по ссылкам
  findItemChildrens(node: SystemNode, newValue: string[], takeAllChilds = false) {
    //если id узла есть в массиве выбранных ids, добавляем узел и его детей в список узлов
    const res = newValue.some((x: string) => x == node.id);
    if (res || takeAllChilds) {
      this.itemChilds.push(node.id);
      // если узел найден, то добавляем в массив все его подузлы (takeAllChilds)
      node.children?.forEach((child: SystemNode) => {
        this.findItemChildrens(child, newValue, true);
      });
    }
    // если не найден узел в полученном списке, то идем вглубь
    node.children?.forEach((child: SystemNode) => {
      this.findItemChildrens(child, newValue);
    });
  }

  linkVisible(item: any) {
    if (this.itemChilds.length == 0 || this.itemChilds?.some(x => x == item.id)) return true;
    return false;
  }
}
